import { PropsWithChildren } from 'react';
import { WagmiProvider } from 'wagmi';
import { config } from '../utils/wagmi.ts';
// RainbowKit styles - stubbed in B2B mode via Vite alias
import '@rainbow-me/rainbowkit/styles.css';

const Wagmi = (props: PropsWithChildren) => (
  <WagmiProvider config={config} {...props} />
);

export { Wagmi };
